import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";
import {LiveCasinoGridItemBetIntervalDefaultBox} from "./live-casino-grid-item-bet-interval.default.box"
import {baseColors} from "../../../../../../themes/definitions/mrgreen/base-colors";

export const LiveCasinoGridItemBetIntervalMrGreenBox = styled(LiveCasinoGridItemBetIntervalDefaultBox)`
    color: ${props => props.theme.colors.brandPrimaryDark};
    background: ${hexToRgba(baseColors.base03, 0.80)};
    border: 1px solid ${hexToRgba(baseColors.gray033, 0.1)};
`;
